const SAC_CATEGORY_MAP = {
  "Stray At Large": "stray_at_large_count",
  "Relinquished By Owner": "relinquished_by_owner_count",
  "Intake Owner-Intended Euthanasia": "owner_intended_euthanasia_count_intake",
  "Transferred in (Undesignated)": "legacy_transferred_in_from_agency_count",
  "Seized or Impounded": "seized_or_impounded_count",
  "Other Intakes": "other_intakes_count",
  Adoption: "adoption_count",
  "Returned To Owner": "returned_to_owner_count",
  "Transfer Out Undesginated": "legacy_transferred_to_another_agency_count",
  "Returned To Field": "returned_to_field_count",
  "Died In Care": "died_in_care_count",
  "Lost In Care": "lost_in_care_count",
  "Shelter Euthanasia": "shelter_euthanasia_count",
  "Outcome Owner-Intended Euthanasia":
    "owner_intended_euthanasia_count_outcome",
  "Other Live Outcome": "do_not_include",
};

export function getUniqueTypeSubtypePairs(data) {
  const uniquePairs = new Set();

  data.forEach((obj) => {
    const eventType = obj.eventType ?? obj.event_type;
    const eventSubtype = obj.eventSubtype ?? obj.event_subtype ?? "";
    const sacCategory = obj.sacCategory ?? obj.sac_category ?? null;
    const eventCategory = obj.eventCategory ?? obj.event_category ?? null;
    const mappedCategory = SAC_CATEGORY_MAP[sacCategory] ?? null;

    const pair = `${eventType}|${eventSubtype}|${mappedCategory}|${eventCategory}`;
    uniquePairs.add(pair);
  });

  return Array.from(uniquePairs).map((pair) => {
    const [eventType, eventSubtype, sacCategory, eventCategory] =
      pair.split("|");
    const key = `${eventType}|${eventSubtype}`;
    return {
      eventType,
      eventSubtype:
        eventSubtype === "null" ||
        eventSubtype === "undefined" ||
        eventSubtype === ""
          ? null
          : eventSubtype,
      key,
      sacCategory,
      event_category: eventCategory,
    };
  });
}

export const intakeCategories = [
  { name: "Stray at Large", value: "stray_at_large_count" },
  { name: "Relinquished by Owner", value: "relinquished_by_owner_count" },
  {
    name: "Owner Intended Euthanasia",
    value: "owner_intended_euthanasia_count_intake",
  },
  {
    name: "Transferred Undesignated",
    value: "legacy_transferred_in_from_agency_count",
  },
  { name: "Seized or Impounded", value: "seized_or_impounded_count" },
  { name: "Other Intakes", value: "other_intakes_count" },
  { name: "Do not include", value: "do_not_include" },
];

export const outcomeCategories = [
  { name: "Adoption", value: "adoption_count" },
  { name: "Return to Owner", value: "returned_to_owner_count" },
  { name: "Return to Field", value: "returned_to_field_count" },
  {
    name: "Transferred Undesignated",
    value: "legacy_transferred_to_another_agency_count",
  },
  { name: "Shelter Euthanasia", value: "shelter_euthanasia_count" },
  { name: "Died in Care", value: "died_in_care_count" },
  { name: "Lost in Care", value: "lost_in_care_count" },
  {
    name: "Owner Intended Euthanasia",
    value: "owner_intended_euthanasia_count_outcome",
  },
  { name: "Do not include", value: "do_not_include" },
];
